<template>
  <div>
    <div class="centered-column">
      <div class="container-header">
        <h3> {{label.get('job_sites')}}</h3>
      </div>

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('preference')}}</label>
          </div>
        </div>
        <div class="toggle-dep no-border job-codes-toggle-dep">
          <div class="check-wrapper switch-wrapper">
            <b-form-checkbox
                v-model="clockInRestrictions"
                @change="toggleClockInRestrictions"
            >
              {{label.get('clock_in_restrictions')}}
            </b-form-checkbox>
            <p class="disclaimer">
              {{label.get('clock_in_restrictions_description')}}
            </p>
          </div>
        </div>
      </div>

      <div class="white-card">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('job_sites')}}</label>
          </div>
          <button
              class="add-new-btn"
              @click="addNewJobSite"
              v-if="job_sites.length"
          >
            <i class="atto atto-add-more" />
            {{ label.get('add_job_site') }}
          </button>
        </div>
        <div class="list-container"
            v-if="job_sites.length"
        >
          <div class="table-heading">
            <span class="heading-label job-site-name">{{label.get('job_site_name')}}</span>
            <span class="heading-label address">{{label.get('address')}}</span>
            <span class="heading-label diameter">{{label.get('diameter')}}</span>
          </div>
          <ul>
            <li
                v-for="(job, idx) in job_sites"
                :key="idx"
            >
             <div class="job-wrapper">
               <div class="location-icon">
                 <i class="atto atto-favorite-location" />
               </div>
               <span class="job-site-name"> {{ job.name }} </span>
               <div class="address">
                 <i class="atto atto-location-marker" />
                 <span class="name">
                  {{ job.address }}
                </span>
               </div>
               <div class="diameter">
                 <i class="atto atto-location-diameter" />
                 <span class="name">
                  {{ job.radius }}
                </span>
               </div>
               <div class="options">
                 <button class="edit-btn">
                   <i
                       class="atto atto-edit-btn"
                       @click="editJobSite(job)"
                   />
                 </button>
                 <button class="delete-btn">
                   <i
                       class="atto atto-delete"
                       @click="deleteJobSite(job)"
                   />
                 </button>
               </div>
             </div>
            </li>
          </ul>
        </div>
        <div
            v-if="!job_sites.length"
            class="no-items"
        >
          <div class="item-wrap">
            <i class="no_job_sites" />
            <button
                class="atto-btn add-entry add-item"
                @click="addNewJobSite"
            >
              {{label.get('add_job_sites')}}
            </button>
            <p>
              {{label.get('add_job_sites_desc')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <add-job-site-component v-if="newJobSite" />
    <edit-job-site-component
        v-if="editSite"
        :job="sitesItem"
    />
    <delete-job-site-component
        v-if="deleteSite"
        :site="sitesItem"
    />
  </div>
</template>

<script>
    import JobSitesService from './services/JobSitesService';
    import AddJobSiteComponent from './components/AddJobSiteComponent';
    import EditJobSiteComponent from './components/EditJobSiteComponent';
    import DeleteJobSiteComponent from './components/DeleteJobSiteComponent';

    export default {
        name: "JobSitesComponent",
        components: {
            AddJobSiteComponent,
            EditJobSiteComponent,
            DeleteJobSiteComponent
        },
        data() {
            return {
                newJobSite: false,
                job_sites: this.$store.state.jobSites,
                sitesItem: null,
                clockInRestrictions: this.$store.state.companySettings.clock_in_restrict,
                editSite: false,
                deleteSite: false
            }
        },
        mounted() {
            this.$root.$on('hideNewJobSiteModal', this.hideNewJobSiteModal);
            this.$root.$on('hideDeleteSite', this.hideDeleteJobSite);
            this.$root.$on('hideEditJobSite', this.hideEditJobSite);
            // this.$root.$on('pushNewJobSite', this.pushJobSites);
        },
        created() {
          this.getJobSites();
        },
        methods: {
          getJobSites() {
            JobSitesService.getFavoriteLocations().then((result) => {
              this.job_sites = result;
            }).catch((error) => {
              console.log(error);
            });
          },
            addNewJobSite() {
                this.newJobSite = true;
            },

            editJobSite(site) {
                this.editSite = true;
                this.sitesItem = site;
            },

            deleteJobSite(site) {
              this.sitesItem = site;
              this.deleteSite = true;
            },

            toggleClockInRestrictions(){

                const _this = this;

                if(_this.debounce){
                    clearTimeout(_this.debounce);
                }
                _this.$store.state.companySettings.clock_in_restrict = !_this.clockInRestrictions;

                const companySettings = _this.$store.state.companySettings;
                _this.debounce = setTimeout(() => {
                    JobSitesService.updateCompanySettings(companySettings).then((result) => {
                        this.$awn.success(result.data.message);
                        this.$store.state.companySettings = companySettings;
                    }).catch((error) => {
                        console.log(error);
                    })
                }, 1000);
            },

            hideNewJobSiteModal(jobSite){
                if(jobSite){
                    this.job_sites.push(jobSite);
                }
                this.newJobSite = false;
            },

            hideDeleteJobSite(site) {
                if (site) {
                    const index = this.job_sites.indexOf(site);
                    this.job_sites.splice(index, 1);
                }
                this.deleteSite = false;
            },

            hideEditJobSite(jobSite) {
              if(jobSite) {
                const index = this.job_sites.indexOf(jobSite);
                if(index >= 0) {
                  this.job_sites[index] = {...jobSite};
                }
              }
              this.editSite = false;
              this.sitesItem = null;
            },
        },
        beforeDestroy() {
          this.$root.$off('hideNewJobSiteModal');
          this.$root.$off('hideDeleteSite');
          // this.$root.$off('pushNewJobSite');
        },
    }
</script>

<style lang="scss" scoped>

 .table-heading{
   padding: 5px 85px 6px 64px !important;
 }

    .job-site-name {
      width: 400px;
    }
    .address {
      width: 700px;
      i{
        margin-right: 8px !important;
      }
      span{
        font: $roboto-regular 0.875rem/1rem $roboto-font !important;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .diameter{
      min-width: 150px;
      width: 10%;

      i{
        margin-right: 8px !important;
      }
      span{
        font: $roboto-regular 0.875rem/1rem $roboto-font !important;
      }
    }


    .toggle-dep p{
      margin-top: 4px;
      color: #666666;
      max-width: 425px;
    }
    .job-wrapper{
      display: flex;
      align-items: center;
      width: 100%;

      div{
        display: flex;
        align-items: center;
      }
    }

</style>
